<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户ID">
                  <el-input  v-model="queryForm.userId"></el-input>
              </el-form-item>
              <el-form-item label="接口密钥">
                  <el-input  v-model="queryForm.apiKey"></el-input>
              </el-form-item>
              <el-form-item label="接口状态">
                  <el-input  v-model="queryForm.status"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getGptApikeyList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addGptApikey"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editGptApikey(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteGptApikey(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportGptApikeyList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshGptApikeyList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="gptApikeyList"
      row-key="id"
      border
      height='100%'
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户ID"
        width="400"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiKey"
        label="接口密钥"
        width="300"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="接口状态"
        width="300"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkGptApikey(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editGptApikey(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteGptApikey(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="gptApikeyStates[gptApikeyState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="gptApikey"
          ref="gptApikeyForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户ID"
            prop="userId"
          >
            <el-input
              size="small"
              v-model="gptApikey.userId"
              :disabled="gptApikeyState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接口密钥"
            prop="apiKey"
          >
            <el-input
              size="small"
              v-model="gptApikey.apiKey"
              :disabled="gptApikeyState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="状态"
            prop="status"
          >
            <el-input
              size="small"
              v-model="gptApikey.status"
              :disabled="gptApikeyState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="gptApikeyState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetGptApikeyList();
                    this.getGptApikeyList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetGptApikeyList();
                    this.getGptApikeyList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户ID
                     apiKey: '', //接口密钥
                     status: '', //状态
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                gptApikeyState: 'add',
                gptApikeyStates: {
                    add: '新建gpt_apikey',
                    check: '查看gpt_apikey',
                    edit: '修改gpt_apikey'
                },

                multipleSelection: [],
                gptApikeyList: [],
                gptApikey: {
                    userId: '', //用户ID
                    apiKey: '', //接口密钥
                    status: '', //状态
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    apiKey: [{ required: true, message: '接口密钥不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getGptApikeyList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetGptApikeyList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.gptApikeyList = [];
            },
            resetDialog() {
                this.gptApikeyState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      apiKey: '', //接口密钥
                      status: '', //状态
                };
                this.getGptApikeyList();
            },
            closeDialog() {
                this.showDialog = false
                this.gptApikey = {
                      userId: '', //用户ID
                      apiKey: '', //接口密钥
                      status: '', //状态
                };
            },
            submitForm() {
                if (this.gptApikeyState == 'add') {
                    this.$refs.gptApikeyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/gpt/apikey/add`,{ ...this.gptApikey }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetGptApikeyList();
                                    this.resetDialog();
                                    this.getGptApikeyList();
                                }
                            });
                        }
                    });
                } else if (this.gptApikeyState == 'edit') {
                    this.$refs.gptApikeyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/gpt/apikey/edit`,{ ...this.gptApikey }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetGptApikeyList();
                                    this.resetDialog();
                                    this.getGptApikeyList();
                                }
                            });
                        }
                    });
                }
            },
            addGptApikey() {
                this.showDialog = true;
                this.gptApikeyState = 'add';
            },
            checkGptApikey(gptApikeyId) {
                console.log(gptApikeyId);
                this.currentGptApikeyId = gptApikeyId;

                this.getGptApikeyById();
                this.showDialog = true;
                this.gptApikeyState = 'check';
            },
            editGptApikey(gptApikeyId) {
                console.log('gptApikey', gptApikeyId);
                if (gptApikeyId) {
                    this.currentGptApikeyId = gptApikeyId;
                    this.getGptApikeyById();
                } else {
                    this.gptApikey = { ...this.gptApikey, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.gptApikeyState = 'edit';
            },
            deleteGptApikey(gptApikeyId) {
                let ids = '';
                if (gptApikeyId) {
                    ids = gptApikeyId;
                } else {
                    ids = this.multipleSelection.map((gptApikey) => gptApikey.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/gpt/apikey/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetGptApikeyList();
                                this.getGptApikeyList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshGptApikeyList() {
                this.resetGptApikeyList();
                this.getGptApikeyList();
            },
            getGptApikeyList(query = {}) {
                this.loading = true;
                get(`/gpt/apikey/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.gptApikeyList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getGptApikeyById() {
                get(`/gpt/apikey/get`,{ id: this.currentGptApikeyId }).then((res) =>{
                    if(res.success){
                      this.gptApikey = { ...this.gptApikey, ...res.gptApikey };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportGptApikeyList() {
                //this.btnLoading = true;
                exprotExcel(`/gpt/apikey/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/gpt/apikey/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/gpt/apikey/importData`,formData);
              this.refreshGptApikeyList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getGptApikeyList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getGptApikeyList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
